module.exports = __webpack_public_path__ + "img/nemalim.ea427589.svg";